import { render } from "./CommentForm.vue?vue&type=template&id=55ca54b8&scoped=true"
import script from "./CommentForm.vue?vue&type=script&lang=js"
export * from "./CommentForm.vue?vue&type=script&lang=js"

import "./CommentForm.vue?vue&type=style&index=0&id=55ca54b8&lang=scss&scoped=true"
import "./CommentForm.vue?vue&type=style&index=1&id=55ca54b8&lang=scss"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55ca54b8"]])

export default __exports__